module.exports = __webpack_public_path__ + "giving/public/shared/assets/bank_account.svg?2a8da11a6582eccc520ba3b6ccb2c43b";